var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.badgeList && _vm.badgeList.length > 0)?_c('div',_vm._l((_vm.badgeList),function(badge,index){return _c('tk-badge',{key:index,attrs:{"badge-text":badge.text,"badge-class":badge.class,"qaid":badge.qaid || badge.id}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }